import styled from "styled-components";
import { theme } from "theme";

export const sidebarWidth = "280px";
export const headerHeight = "70px";

export const LayoutMain = styled.div`
  height: 100vh;
  background-color: ${theme.palette.background.default};
  display: flex;
  flex-direction: column;

  .main-header {
    width: 100%;
    height: ${headerHeight};
    background: linear-gradient(135deg, ${theme.palette.primary.main} 0%, ${theme.palette.secondary.main} 100%);
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 ${theme.spacing(3)};
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
    z-index: 1000;
    backdrop-filter: blur(10px);

    .brand-section {
      display: flex;
      align-items: center;
      gap: ${theme.spacing(2)};

      .brand-logo {
        width: 40px;
        height: 40px;
        background: linear-gradient(135deg, ${theme.palette.background.paper} 0%, ${theme.palette.grey[100]} 100%);
        border-radius: 12px;
        display: flex;
        align-items: center;
        justify-content: center;
        font-weight: bold;
        color: ${theme.palette.primary.main};
        font-size: 18px;
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
        transition: all 0.2s ease;
        
        &:hover {
          transform: scale(1.05);
          box-shadow: 0 6px 16px rgba(0, 0, 0, 0.15);
        }
      }

      .brand-title {
        color: ${theme.palette.background.paper};
        font-weight: 600;
        font-size: 20px;
      }
    }

    .user-section {
      display: flex;
      align-items: center;
      gap: ${theme.spacing(2)};
      color: ${theme.palette.background.paper};

      .user-info {
        display: flex;
        align-items: center;
        gap: ${theme.spacing(1)};
        padding: ${theme.spacing(1)} ${theme.spacing(2)};
        background: rgba(255, 255, 255, 0.15);
        border-radius: 20px;
        backdrop-filter: blur(10px);
        border: 1px solid rgba(255, 255, 255, 0.2);
        transition: all 0.2s ease;
        
        &:hover {
          background: rgba(255, 255, 255, 0.25);
          transform: translateY(-1px);
        }
      }
    }
  }

  .layout-body {
    display: flex;
    flex: 1;
    overflow: hidden;
  }

  .main-sidebar {
    width: ${sidebarWidth};
    background: linear-gradient(180deg, ${theme.palette.background.paper} 0%, ${theme.palette.grey[50]} 100%);
    border-left: 1px solid ${theme.palette.grey[200]};
    display: flex;
    flex-direction: column;
    box-shadow: -4px 0 20px rgba(0, 0, 0, 0.08);

    .header {
      padding: ${theme.spacing(4)} ${theme.spacing(3)};
      text-align: center;
      border-bottom: 1px solid ${theme.palette.grey[200]};
      background: linear-gradient(135deg, ${theme.palette.primary.light}20 0%, ${theme.palette.secondary.light}20 100%);
      backdrop-filter: blur(10px);

      .profile-avatar {
        margin: 0 auto ${theme.spacing(2)} auto;
        width: 60px;
        height: 60px;
        background: linear-gradient(135deg, ${theme.palette.primary.main} 0%, ${theme.palette.secondary.main} 100%);
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
        border: 3px solid ${theme.palette.background.paper};
        transition: all 0.2s ease;
        
        &:hover {
          transform: scale(1.05);
          box-shadow: 0 6px 16px rgba(0, 0, 0, 0.2);
        }
      }

      .user-name {
        font-weight: 600;
        color: ${theme.palette.grey[800]};
        margin-bottom: ${theme.spacing(0.5)};
      }

      .user-role {
        font-size: 12px;
        color: ${theme.palette.grey[500]};
        background: ${theme.palette.primary.light};
        color: ${theme.palette.primary.dark};
        padding: ${theme.spacing(0.5)} ${theme.spacing(1.5)};
        border-radius: 12px;
        display: inline-block;
      }
    }

    .menu-items {
      flex: 1;
      padding: ${theme.spacing(2)} 0;
      overflow-y: auto;

      .menu-section {
        margin-bottom: ${theme.spacing(3)};

        .section-title {
          color: ${theme.palette.grey[500]};
          font-size: 11px;
          font-weight: 600;
          text-transform: uppercase;
          letter-spacing: 0.5px;
          padding: 0 ${theme.spacing(3)} ${theme.spacing(1)} ${theme.spacing(3)};
          margin-bottom: ${theme.spacing(1)};
        }

        ul {
          list-style: none;
          margin: 0;
          padding: 0;

          li {
            display: flex;
            align-items: center;
            gap: ${theme.spacing(2)};
            padding: ${theme.spacing(1.5)} ${theme.spacing(3)};
            margin: 0 ${theme.spacing(1)};
            border-radius: 12px;
            cursor: pointer;
            transition: all 0.2s ease;
            position: relative;

            &:hover {
              background: linear-gradient(135deg, ${theme.palette.primary.light}20 0%, ${theme.palette.secondary.light}20 100%);
              transform: translateX(2px);
              color: ${theme.palette.primary.main};
            }

            &.--active {
              background: linear-gradient(135deg, ${theme.palette.primary.main} 0%, ${theme.palette.secondary.main} 100%);
              box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
              color: ${theme.palette.background.paper};

              &::before {
                content: '';
                position: absolute;
                right: -${theme.spacing(1)};
                top: 50%;
                transform: translateY(-50%);
                width: 4px;
                height: 20px;
                background: ${theme.palette.primary.main};
                border-radius: 2px;
              }

              svg,
              .menu-item-link {
                color: ${theme.palette.background.paper};
              }
            }

            svg {
              color: ${theme.palette.grey[600]};
              font-size: 20px;
            }

            .menu-item-link {
              color: ${theme.palette.grey[700]};
              font-weight: 500;
              font-size: 14px;
            }
          }
        }
      }
    }

    .footer {
      padding: ${theme.spacing(2)} ${theme.spacing(3)};
      border-top: 1px solid ${theme.palette.grey[100]};
      background: ${theme.palette.grey[50]};

      .logout-btn {
        display: flex;
        align-items: center;
        gap: ${theme.spacing(1.5)};
        width: 100%;
        padding: ${theme.spacing(1.5)};
        background: transparent;
        border: 1px solid ${theme.palette.error.light};
        border-radius: 8px;
        color: ${theme.palette.error.main};
        font-weight: 500;
        transition: all 0.2s ease;
        cursor: pointer;
        text-transform: none;

        &:hover {
          background: ${theme.palette.error.light};
          color: ${theme.palette.error.dark};
        }

        svg {
          font-size: 18px;
        }
      }
    }
  }

  .main-content {
    flex: 1;
    background: ${theme.palette.background.default};
    overflow-y: auto;
    padding: ${theme.spacing(3)};
    position: relative;

    .spacing {
      margin-top: ${theme.spacing(8)};
    }
    
    @media (max-width: 768px) {
      padding: ${theme.spacing(2)};
    }
    
    @media (max-width: 480px) {
      padding: ${theme.spacing(1)};
    }
  }

  .toolbar {
    display: none;
  }

  .logout-btn-mobile {
    display: none;
  }
  
  .logout-btn-desktop {
    display: none;
  }

  @media (max-width: 768px) {
    .main-sidebar {
      position: fixed;
      top: ${headerHeight};
      right: -${sidebarWidth};
      height: calc(100vh - ${headerHeight});
      z-index: 999;
      transition: right 0.3s ease;
      box-shadow: -4px 0 16px rgba(0, 0, 0, 0.1);

      &.mobile-open {
        right: 0;
      }
    }

    .main-content {
      padding: ${theme.spacing(2)};
      padding-bottom: 90px; /* Space for mobile toolbar */
      
      .spacing {
        margin-top: ${theme.spacing(4)};
      }
    }

    .toolbar {
      display: flex;
      justify-content: space-around;
      position: fixed;
      right: 0;
      width: 100%;
      bottom: 0;
      background: linear-gradient(135deg, ${theme.palette.primary.main} 0%, ${theme.palette.secondary.main} 100%);
      padding: ${theme.spacing(2)} ${theme.spacing(1)};
      box-shadow: 0 -4px 20px rgba(0, 0, 0, 0.15);
      z-index: 1000;
      backdrop-filter: blur(10px);
      gap: ${theme.spacing(1)};

      .toolbar-btn {
        background: rgba(255, 255, 255, 0.15);
        border: 1px solid rgba(255, 255, 255, 0.2);
        color: ${theme.palette.background.paper};
        backdrop-filter: blur(10px);
        transition: all 0.2s ease;
        border-radius: 12px;
        min-width: 60px;
        height: 50px;
        flex: 1;
        max-width: 80px;

        &:hover {
          background: rgba(255, 255, 255, 0.25);
          transform: translateY(-2px);
          box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
        }
        
        svg {
          font-size: 20px;
        }
      }
    }

    .logout-btn-mobile {
      display: flex;
      background: transparent;
      border: none;
      color: ${theme.palette.background.paper};
      padding: ${theme.spacing(1)};
      border-radius: 50%;
      transition: all 0.2s ease;
      
      &:hover {
        background: rgba(255, 255, 255, 0.1);
        transform: scale(1.05);
      }
      
      svg {
        font-size: 20px;
      }
    }
    
    .logout-btn-desktop {
      display: flex;
      background: transparent;
      border: none;
      color: ${theme.palette.background.paper};
      padding: ${theme.spacing(1)};
      border-radius: 50%;
      transition: all 0.2s ease;
      
      &:hover {
        background: rgba(255, 255, 255, 0.1);
        transform: scale(1.05);
      }
      
      svg {
        font-size: 20px;
      }
    }

    .main-header {
      .brand-title {
        font-size: 16px;
      }

      .user-section {
        .user-info {
          display: none;
        }
      }
    }
  }

  @media (max-width: 480px) {
    .main-content {
      padding: ${theme.spacing(1)};
      
      .spacing {
        margin-top: ${theme.spacing(3)};
      }
    }

    .main-header {
      padding: 0 ${theme.spacing(2)};

      .brand-section {
        .brand-logo {
          width: 32px;
          height: 32px;
          font-size: 14px;
        }

        .brand-title {
          font-size: 14px;
        }
      }
    }
  }
`;
